import React from "react";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";

const CustomSelect = ({
  id,
  label,
  value,
  required,
  options,
  name,
  errors,
  touched,
  placeholder,
  setFieldTouched,
  setFieldValue,
  isClearable,
  showLabel = true,
  ...props
}) => {
  return (
    <FormGroup>
      {showLabel && (
        <Label className="mb-0">
          {label} {required && <sup className="text-danger">*</sup>}
        </Label>
      )}
      <Select
        id={id}
        name={name}
        options={options}
        value={value}
        placeholder={placeholder}
        isClearable={isClearable}
        onChange={(e) => {
          setFieldValue(`${name}`, e);
        }}
        onBlur={() => {
          setFieldTouched(`${name}`, true);
        }}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: errors && touched ? "#F17171" : "#CED4DA",
          }),
        }}
        {...props}
      />
      {errors && touched && (
        <span style={{ fontSize: "0.875em" }} className="fs-8 text-danger">
          {errors}
        </span>
      )}
    </FormGroup>
  );
};

export default CustomSelect;
